module.exports = __webpack_public_path__ + "img/row-srp-preview-chevy.3dea0e4e.png";